import React, { useState } from "react";
import { Globe } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (newLang) => {
    setLang(newLang);
    setIsOpen(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="bg-slate-700/70 text-white w-10 h-10 sm:w-12 sm:h-12 rounded-lg shadow-md backdrop-blur-sm flex items-center justify-center hover:bg-slate-800/80 transition-colors duration-150"
        aria-label={lang === "hi" ? "भाषा चुनें" : "Select language"}
      >
        <Globe size={18} />
      </button>
      <span className="text-sm font-bold leading-none text-slate-700 bg-white px-2 py-1 rounded-full shadow-md">
        Aa/अ
      </span>

      {isOpen && (
        <div
          className="fixed inset-0 z-[1001] flex items-center justify-center p-4 bg-black/50"
          onClick={() => setIsOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Select language"
        >
          <div
            className="bg-white rounded-lg shadow-md max-w-sm w-full p-6 border border-slate-200"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-bold text-slate-900 mb-4">
              {lang === "hi" ? "भाषा चुनें" : "Select Language"}
            </h3>
            <div className="space-y-2">
              <button
                type="button"
                onClick={() => handleSelect("en")}
                className={`w-full flex items-center justify-between gap-3 rounded-lg border-2 p-4 text-left transition-colors duration-150 ${
                  lang === "en"
                    ? "border-red-600 bg-red-50 text-red-800"
                    : "border-slate-200 hover:border-slate-300 bg-white text-slate-700"
                }`}
              >
                <span className="font-semibold">English</span>
                {lang === "en" && <span className="text-red-600 font-bold">✓</span>}
              </button>
              <button
                type="button"
                onClick={() => handleSelect("hi")}
                className={`w-full flex items-center justify-between gap-3 rounded-lg border-2 p-4 text-left transition-colors duration-150 ${
                  lang === "hi"
                    ? "border-red-600 bg-red-50 text-red-800"
                    : "border-slate-200 hover:border-slate-300 bg-white text-slate-700"
                }`}
              >
                <span className="font-semibold">हिंदी</span>
                {lang === "hi" && <span className="text-red-600 font-bold">✓</span>}
              </button>
            </div>
            <p className="mt-4 text-xs text-slate-500 text-center">
              {lang === "hi"
                ? "पूरी वेबसाइट चुनी हुई भाषा में दिखेगी।"
                : "The entire website will display in the selected language."}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default LanguageSwitcher;
